import { createContext, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PageContext = createContext<any>({});

export const usePageContext = () => {
  return useContext(PageContext);
};
